import configureStore, { history } from './configureStore';
import initialState from './initialState';

const store = configureStore(initialState);

export { store, history };
